export const trackIdentify = (email: string): void => {
	try {
		window.Trialfire?.identify(undefined, {email: email});
	} catch (e) {
		console.error(e);
	}
};
